import { isDesignMode } from '@/common/util/util';
const CnLayoutContent = (props) => {
    const { children, normalStyle } = props || {};
    const extraProps = {
        ...normalStyle,
    };
    const isDesign = isDesignMode(props);
    if (isDesign) {
    }
    return children;
};
CnLayoutContent.displayName = 'CnLayoutContent';
export default CnLayoutContent;
export { CnLayoutContent };
